module.exports = __webpack_public_path__ + "static/media/gotham-bold.f83805fc.woff2";